import React, { useRef } from "react";
import { Checkbox,  Dialog, DialogActions, DialogContent, DialogTitle, Button, FormControl, RadioGroup, FormControlLabel, FormLabel, Radio } from "@mui/material";
import { Annotation } from '../objects/Annotation.interface';
import { Entity } from '../objects/Entity.interface';
import { Document } from '../objects/Document.interface';
import { Props } from "./Anotador";
import { EntitiesService } from '../services/Entities.service';
import CorpusComponent from "./ContextMenuHandler";
import { AnnotationService, createNewAnnotation } from "../services/Annotations.service";
import { DocumentService } from "../services/Documents.service";
import { FileParser } from "../tools/FileParser";
import { Field } from "../objects/Field.interface";
import { basicFormatString, convertStringToDOM, findNewAnnotationsInText, joinAnnotationsSelected, readBinaryContent, removeSpecialCharacters, updateIndexAnnotationsByJoin, updateParagraphAnnotationsByJoin } from '../tools/Utils';
import { ComunicationService } from "../notifications/comunication.service";
import { Project } from '../objects/Project.interface';
import { ExportData } from "../tools/ExportData";
import { ANNOTATOR_TOOL_DEFAULT_HEIGHT, ANNOTATOR_TOOL_DETAILS_HEIGHT, ANNOTATOR_TOOL_LABELS_HEIGHT, ANNOTATOR_TOOL_STATUS, ANNOTATOR_TOOL_STATUS_HIDDEN, ANNOTATOR_TOOL_STATUS_SHOW, ANOTATOR_DEFAULT_TEXT_SIZE, EXPORT_FORMAT_NER, EXPORT_FORMAT_TAGTOG } from "../tools/Contants";
import DocumentList from "./DocumentList";
import { createNewProject } from "../services/Projects.service";
import { PlaceNameStatsItem } from '../objects/PlaceNameStats.interface';
import LabelMatches from "../SubComponents/LabelMatches";


import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { animated, useSpring } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import ToolList from "./ToolList";
import ToolLabelList from "./ToolLabelList";





class Anotator extends React.Component<Props, {annotationSelected: Annotation, 
                                                openExportDialog: boolean, 
                                                exportFormatSelected: string, 
                                                isOverAnnotations:boolean, 
                                                isSavingAnnotation:boolean, 
                                                isOpenNewDocument:boolean, 
                                                placeNamesList: Annotation[], 
                                                heightDetails: number, 
                                                heightLabels:number, 
                                                activeDragDetails: boolean,
                                                activeDragLabels: boolean,
                                                dropdownToolDetailsRef : HTMLButtonElement | null, 
                                                dropdownToolLabelsRef: HTMLButtonElement | null,
                                                containerDetailsRef: HTMLDivElement | null, 
                                                detailsContentRef: HTMLDivElement | null,
                                                labelsContentRef: HTMLDivElement | null}>{

    
    _corpusContainerHTML!:HTMLElement;
    _corpusTitleHTML!:HTMLElement;
    _textSelected:string = '';
    _isOverCorpusContent:boolean = false;
    _anotationMode:boolean = true;
    _currentDocument: Document | undefined = undefined;
    _AnnotationsSelectedList: Annotation[] = [];
    _annotationsList:Annotation[] = [];
    _tmpAnotationSelected:Annotation = createNewAnnotation(this._currentDocument?.id!);


    openExportDialog:boolean = false;
    _currentProject:Project = createNewProject();
    _currentProjectId:number= 0;

    _statusClickSave: number = 0;
    textPlain:string = '';
    textSize:string = ANOTATOR_DEFAULT_TEXT_SIZE;
    entityFields: string[] = [];

    private entityService = new EntitiesService();
    private _documentService = new DocumentService();
    private _annotationsService = new AnnotationService();
    private _communicationService = new ComunicationService();
    private _parseFileService: FileParser = new FileParser();
    private _exportService: ExportData = new ExportData();

    entityList: Entity[]=[];
    documentList: Document[] = [];
    documentAll:Document[]=[];

    firstEntityFieldList:Field[] = [];
    currentFirstEntitySecondField:string = '-1';
    currentFirstEntityFirstField:string = '-1';
    secondEntityFieldList:Field[] = [];


    constructor(props:Props){
        
        super(props);

        if(props.Project)
        {
            this._currentProject = props.Project;
            this.state = {
                annotationSelected : this._tmpAnotationSelected,
                openExportDialog: false,
                exportFormatSelected: '',
                isOverAnnotations: false,
                isSavingAnnotation: false,
                isOpenNewDocument: false,
                placeNamesList: [],
                heightDetails: this.getDetailsToolHeight(),
                heightLabels: this.getLabelsToolHeight(),
                activeDragDetails: false,
                activeDragLabels: false,
                dropdownToolDetailsRef: null,
                dropdownToolLabelsRef: null,
                containerDetailsRef: null,
                detailsContentRef: null,
                labelsContentRef: null
            };
            this._currentProjectId = (sessionStorage.getItem('currentProjectId'))?parseInt(sessionStorage.getItem('currentProjectId')!):1;
        }
        if(this.entityList.length === 0)
        {
            this.loadEntities();
        }


        this.initDocuments();

        document.addEventListener('keyup', e  => {
            e.stopPropagation();
            if(e.ctrlKey && e.key === 's'){
                this.handleSaveDraftAnnotations();
            }
        })

        document.addEventListener('mouseup', e => {
            e.stopPropagation();

            if(this.handleGetIsOverCorpus()){
                this.textSelection();
            }
            
             
        });

        this._communicationService.currentRefreshStatus.subscribe(status => {
            if(status)
            {
                this.showDocumentWithAnnotations();
            }
        });
    
    }

    //after component is loaded
    componentDidMount(): void {
        this.handleGetToolStatus();

        const dropdownToolDetailsRefHTMLElement = document.getElementById('dropdown-btn-details') as HTMLButtonElement;
        this.setState({dropdownToolDetailsRef: dropdownToolDetailsRefHTMLElement});

        const dropdownToolLabelsRefHTMLElement = document.getElementById('dropdown-btn-labels') as HTMLButtonElement;
        this.setState({dropdownToolLabelsRef: dropdownToolLabelsRefHTMLElement});

        const containerDetailsRefHTMLElement = document.getElementById('containerDetailsRef') as HTMLDivElement;
        this.setState({containerDetailsRef: containerDetailsRefHTMLElement});


    }

    handleChangeTextSize(size:string){
        const elements = document.getElementsByClassName('area-corpus-content');

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i] as HTMLElement; 
            element.style.fontSize = size + 'px';
        }        
    }

    handleSaveDraftAnnotations = () => {
        if(this._AnnotationsSelectedList.length > 0){
            this.updateDraftStatusSelected();
            //Guardo las nuevas anotaciones    
            this.setState({isOverAnnotations:false});
            this.setState({isSavingAnnotation:true});
            var result = this._annotationsService.updateBulk(this._AnnotationsSelectedList);
            result.then(result => {
                this.updateDocumentStats();
                //muestro las nuevas anotaciones
                this._AnnotationsSelectedList = [];
                this.setState({annotationSelected: this._tmpAnotationSelected});
                this._tmpAnotationSelected = this.state.annotationSelected;
                this.showDocumentWithAnnotations();
            });
        }
    }
    handleSaveAnnotations = () => {
        if(this._AnnotationsSelectedList.length > 0){
            this.updateEntitySelected();
            //Guardo las nuevas anotaciones    
        
           var result = this._annotationsService.addBulk(this._AnnotationsSelectedList);
            result.then(result => {
                
                this._annotationsService.getByDocumentId(this._currentDocument?.id!).then(annotations => {
                    var filtered =  annotations.filter(item => item.text.toLowerCase() === this._tmpAnotationSelected.text.toLowerCase());
                    if(filtered.length > 0){
                        this._AnnotationsSelectedList = [];
                        this._AnnotationsSelectedList = this._annotationsList.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) === basicFormatString(this._tmpAnotationSelected.text));
                    }           
                    this.showDocumentWithAnnotations();
                });
            });
            this.showDocumentWithAnnotations();
        }
        this.showDocumentWithAnnotations();
    }

    handleUpdateAnnotations = () => {
        if(this._annotationsList.length > 0){
            this.updateEntitySelected();
            //Guardo las nuevas anotaciones    
            
            var result = this._annotationsService.updateBulk(this._AnnotationsSelectedList);
        
            result.then(result => {

                //muestro las nuevas anotaciones
                this._AnnotationsSelectedList = [];
                this._tmpAnotationSelected.text = "";
                this.showDocumentWithAnnotations();
            });
        }
    }
    

    //#region Seleccion de entidades y campos en la parte de detalles de la anotacion
    //quitar cuando no sea necesario el picklist de corpus de arriba
   
    updateEntitySelected = () => {
        this._AnnotationsSelectedList.forEach((annSelected) => {
            annSelected.firstEntityId = this._tmpAnotationSelected.firstEntityId;
            annSelected.secondEntityId = this._tmpAnotationSelected.secondEntityId;
            annSelected.firstEntityCode = this._tmpAnotationSelected.firstEntityCode;
            annSelected.secondEntityCode = this._tmpAnotationSelected.secondEntityCode;
            annSelected.fieldsFirstEntity =  this._tmpAnotationSelected.fieldsFirstEntity;
            annSelected.fieldsSecondEntity = this._tmpAnotationSelected.fieldsSecondEntity;
        });
    }

    updateDraftStatusSelected = () =>{
        this._AnnotationsSelectedList.forEach((annSelected) => {
            if(annSelected.firstEntityId !== -1)
                annSelected.status = 'Saved';
        });
    }
    handleFirstEntitySelected = (e:any) => {
        let entitySelected = -1;
        if(e.target)
            entitySelected = parseInt(e.target.value);
        else
            entitySelected = parseInt(e);
        var firstEntity:Entity|undefined = this.getEntityById(entitySelected);

        if(firstEntity){
            if(e.target){
                this._tmpAnotationSelected.firstEntityId = firstEntity.id!;
                this._tmpAnotationSelected.firstEntityCode = firstEntity.Code;
                this._tmpAnotationSelected.fieldsFirstEntity = [];
            }
            this.firstEntityFieldList = firstEntity.FieldList!;
        }
        else{
            this._tmpAnotationSelected.firstEntityId = -1;
            this._tmpAnotationSelected.firstEntityCode = '';
            this._tmpAnotationSelected.fieldsFirstEntity = [];
            this.firstEntityFieldList = [];
        }
        
        this.forceUpdate();
        
        if(e.target){
            console.log(this._tmpAnotationSelected);
            this.updateEntitySelected();
        }
        
    }

    handleSecondEntitySelected = (e:any) => {
        let entitySelected = -1;
        if(e.target)
            entitySelected = parseInt(e.target.value);
        else
            entitySelected = parseInt(e);

        var secondEntity:Entity|undefined = this.getEntityById(entitySelected);

        if(secondEntity){
            if(e.target){
                this._tmpAnotationSelected.secondEntityId = secondEntity.id!;
                this._tmpAnotationSelected.secondEntityCode = secondEntity.Code;
                this._tmpAnotationSelected.fieldsSecondEntity =[];
            }
            this.secondEntityFieldList = secondEntity.FieldList!;
            
        }
        else{
            this._tmpAnotationSelected.secondEntityId = -1;
            this._tmpAnotationSelected.secondEntityCode = '';
            this._tmpAnotationSelected.fieldsSecondEntity = [];
            this.secondEntityFieldList = [];
        }

        this.forceUpdate();
        //this.updateEntitySelected();
    }

    setFirstField = (e:any, entitySelected:number) => {
        var fieldCodes:string[]|undefined = [];

        if(entitySelected === 1)
        fieldCodes = this._tmpAnotationSelected.fieldsFirstEntity;
        if(entitySelected === 2)
        fieldCodes = this._tmpAnotationSelected.fieldsSecondEntity;

        if(fieldCodes === undefined)
            fieldCodes = [];

        if(e.target.value !== '-1')
        {
            if(fieldCodes.length >= 1 && fieldCodes)
                fieldCodes[0] = e.target.value;

            if(fieldCodes.length === 0 && fieldCodes)
                fieldCodes.push(e.target.value);
        }
        else
        {
            fieldCodes.pop();
        }
        
    } 


    setSecondField = (e:any, entitySelected:number) => {
        var fieldCodes:string[]|undefined = [];
        
        if(entitySelected === 1)
        fieldCodes = this._tmpAnotationSelected.fieldsFirstEntity;
        if(entitySelected === 2)
        fieldCodes = this._tmpAnotationSelected.fieldsSecondEntity;

        if(fieldCodes === undefined)
            fieldCodes = [];
        if(e.target.value !== '-1')
        {
            if(fieldCodes.length === 2 && fieldCodes)
                fieldCodes[1] = e.target.value;

            if(fieldCodes.length === 1 && fieldCodes)
                fieldCodes.push(e.target.value);
        }else if(fieldCodes.length === 2)
        {
            fieldCodes.pop();
        }
        console.log(this._tmpAnotationSelected);
    } 
    //#endregion

    //#region MANEJADORES DE EVENTOS DE SELECCION Y BUSQUEDA DE ENTIDADES Y FIELDS
    /**
     * Inicia la busqueda de las entidades y campos seleccionados en la lista de entidades
     */
    handleSearchAnnotations = () => {
        this.entityFields = [];

        this.entityList.forEach((entity) => {
            let fieldsSelected: Field[] = entity.FieldList!.filter((field) => field.selected === true);
            let fieldsCodes:string [] = fieldsSelected.map((field) => field.code);
            fieldsCodes.forEach((fieldsCode) => this.entityFields.push(fieldsCode));
        
        });
        this.showDocumentWithAnnotations(); 
    }

    /**
     * 
     * @param entity 
     * @returns 
     */
     handleCheckSemiSelected = (entity: Entity):boolean => {
        let isSemiSelected: boolean = false;
        let selectedValues = entity.FieldList!.map(field => field.selected);
        let numberOfTrue = selectedValues.filter((value) => value === true).length;
        if(numberOfTrue > 0 && numberOfTrue < entity.FieldList!.length)
            isSemiSelected = true;
        return isSemiSelected;
    }
    handleFieldCheckChange = (field:Field) =>{
        field.selected = !field.selected;
        this.forceUpdate();
        this.handleSearchAnnotations();
    }
    handleEntityCheckChange = (entity:Entity)  => {
        entity.selected = !entity.selected;
            
        entity.FieldList?.forEach((field) => {
            if(entity.selected)
                field.selected = true;    
            else
                field.selected = false;
        });
        this.forceUpdate();

        this.handleSearchAnnotations();
    }
    handleFieldListStatus =  (entityId:Number,listId:string) => {
        // Check if user has entered the file
        let entityListEmptyDOMElement = document.getElementById(listId + entityId);
        if(entityListEmptyDOMElement)
        {
            if(entityListEmptyDOMElement.style.display === "block")
                entityListEmptyDOMElement.style.display = "none";
            else
                entityListEmptyDOMElement.style.display = "block";
        }
    }
    handleLabelListStatus =  (fieldId:String, listId:string) => {
        // Check if user has entered the file
        let entityListEmptyDOMElement = document.getElementById(listId + fieldId);
        if(entityListEmptyDOMElement)
        {
            if(entityListEmptyDOMElement.style.display === "block")
                entityListEmptyDOMElement.style.display = "none";
            else
                entityListEmptyDOMElement.style.display = "block";
        }
    }
    //#endregion

    /**
     * Inicializador de carga de un nuevo documento de texto (corpus) para agregar a la lista
     * @param e Evento de selecccion de documento de texto (corpus)
     */
     handleFileChange = (e:any) => {
        // Check if user has entered the file
        if (e.target.files.length) {
            this._parseFileService.parseFiles(e.target.files,this._currentProjectId, this.documentAll).then(result => {
                this.initDocuments();
                //window.location.reload();
            });
        }
    }

    /**
     * Obtiene el listado de documentos y carga el primero de la lista
     */
    initDocuments = () => {
        var result = this._documentService.getList(this._currentProjectId);
        result.then(res => {
            this.documentList = res? (res as Document[]): ([] as Document[]);      
            this.documentList.sort((a, b) => a.sort - b.sort);
            if(this.documentList.length > 0){
                this.documentList[0].isSelected = true;
                this.showDocument(this.documentList[0]);
                this.forceUpdate();
               
            }
        });

        var resultAll = this._documentService.getAll();
        resultAll.then(res=> {
            this.documentAll = res? (res as Document[]): ([] as Document[]); 

        });
    };  
    /**
     * Muestra el contenido del documento seleccionado en el recuadro de cospus
     * @param doc documento a mostrar
     */
    showDocument = (doc:Document) => {
        //load corpus title
        this._corpusTitleHTML = document.getElementById("document-title")!;
        this._corpusTitleHTML.innerHTML = "";
        this._corpusTitleHTML.insertAdjacentHTML('beforeend', doc.title);
        this._currentDocument = doc;
        this.clearAnnotationSelected(doc);
        sessionStorage.setItem('currentDocumentId', doc.id!.toString());
        this.textPlain = removeSpecialCharacters( readBinaryContent(this._currentDocument?.textContent));
        this.documentList.forEach(document => {
            if(document.id! === doc.id!)
            {
                document.isSelected = true;
            }
            else
            {
                document.isSelected = false;
            }
        });
        this.updateDocumentStats();
        this.handleSearchAnnotations();
    };

    clearAnnotationSelected = (doc:Document) =>{
        var storageCurrentProjectId = parseInt(sessionStorage.getItem('currentProjectId')!);
        
        if(storageCurrentProjectId === this._currentProject.id){

        this._tmpAnotationSelected = createNewAnnotation(doc.id);

        this.setState({annotationSelected: this._tmpAnotationSelected, isOpenNewDocument:true});
        }
    }

    handleAllowContextMenu = () =>{
        this.setState({isOpenNewDocument:false});
    }

    setSort=(list:Document[]) =>{
        this.documentList = list;
        this.forceUpdate();
    }

    showDocumentWithAnnotations = () => {
        var corpus_section =document.getElementById("document-container")!;
        
        
        var annotationResult = this._annotationsService.getByDocumentId(this._currentDocument?.id!);
        annotationResult.then(annotations => {  
            this._annotationsList = annotations;
          
            let annFilterByFields = annotations.filter((ann) => {
                let first = ann.fieldsFirstEntity!.some((field) => this.entityFields.includes(field)) || this.entityFields.includes('f_WOF_'+ann.firstEntityCode.split('_')[1]+'0');
                let second = ann.fieldsSecondEntity!.some((field) => this.entityFields.includes(field)) || this.entityFields.includes('f_WOF_'+ann.secondEntityCode.split('_')[1]+'0');
                return first || second && ann.status === 'Saved';
            });

            let draftAnnotations = annotations.filter((ann)=> {
                return ann.status === 'Draft';
            });

            this._AnnotationsSelectedList = draftAnnotations;
            var corpusText = convertStringToDOM(corpus_section,this.textPlain,this._AnnotationsSelectedList, annFilterByFields, this.entityList);
            corpus_section.innerHTML = "";
            corpus_section.insertAdjacentHTML('beforeend',corpusText);

            this.setClickEventAnnotations();
            this.textSize = (sessionStorage.getItem('textSize') !== null)?sessionStorage.getItem('textSize')!:ANOTATOR_DEFAULT_TEXT_SIZE;
            this.handleChangeTextSize(this.textSize);
            this.handleSetScrollCorpus(corpus_section);
            this.state.placeNamesList.forEach(item => {
                this.showShadow(item.id!);
            });

    
        });
        
    }

    setClickEventAnnotations = () => {
        const annotationsSpans = Array.from(document.getElementsByClassName('annotated-content'));
        annotationsSpans.forEach(span => {
            span.addEventListener('click', (event:any) => {
                
                if(!span.getAttribute("id")?.includes("tmp")){
                    var annotationSelectedId = (!span.getAttribute("id")?.includes("tmp"))?parseInt(span.getAttribute("id")!.toString()):undefined;
                    if(annotationSelectedId)
                    {
                        this._annotationsService.get(annotationSelectedId).then(annotation => {
                            if(annotation){
                                this._AnnotationsSelectedList = [];
                                this.handleFirstEntitySelected(annotation.firstEntityId);
                                this.handleSecondEntitySelected(annotation.secondEntityId);
                                this._tmpAnotationSelected = annotation;
                                this.setState({annotationSelected: annotation});
                                this._AnnotationsSelectedList = this._annotationsList.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) === basicFormatString(this._tmpAnotationSelected.text));
                                this.showDocumentWithAnnotations();
                                
                            }     
                        });
                    }
                }else if(span.getAttribute("id")?.includes("tmp")){
                    this._AnnotationsSelectedList = this._AnnotationsSelectedList.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) !== basicFormatString(span.getAttribute("keywords")!));    
                    this.showDocumentWithAnnotations();
                }                    
              });

            span.addEventListener('mouseover', (event:any) => {
                this.setState({isOverAnnotations:true});
                this.setState({isSavingAnnotation:false});
            });

            span.addEventListener('mouseout', (event:any) => {
                this.setState({isOverAnnotations:false});
            });
        });
    }

    refreshCurrentAnnotation = () => {
        if(this._tmpAnotationSelected.id){
         
            this._annotationsService.get(this._tmpAnotationSelected.id).then(annotation => {
                if(annotation){
                    this.handleFirstEntitySelected(annotation.firstEntityId);
                    this.handleSecondEntitySelected(annotation.secondEntityId);
                    this._tmpAnotationSelected = annotation;
                    this.setState({annotationSelected: annotation});
                }   
                
                this.showDocumentWithAnnotations();
            });
        }
    };

    handleShowAnnotations = () => this.showDocumentWithAnnotations();

    handleSetScrollCorpus = (corpus_section:HTMLElement) => {
        var scrollpos = sessionStorage.getItem('scrollpos');
        if (scrollpos) {
            corpus_section.scrollTo(0,parseFloat(scrollpos));
        }
        this.forceUpdate();
    }

    handleGetIsOverCorpus = ():boolean => {
        var result:boolean = false;
        var isOver = sessionStorage.getItem('isOverCorpus');
        if (isOver) {
            if(isOver === 'true')
                result = true;
        }


        return result;
    }

    textSelection = () =>{
        var page_content = document.getElementById('document-container')!.innerText;
        var sel = window.getSelection()!;
        if(sel.rangeCount !== 0)
        {
            var range = sel.getRangeAt(0).cloneRange();
            var markerTextChar = range.cloneContents()!;
            var storageCurrentProjectId = parseInt(sessionStorage.getItem('currentProjectId')!);
            var storageCurrentDocumentId = parseInt(sessionStorage.getItem('currentDocumentId')!);

            if(markerTextChar.textContent!.length >= 2 && this._currentDocument === undefined){
                var result = this._documentService.getDocument(storageCurrentDocumentId);
                result.then(documents => {
                    if(documents.length > 0)
                    {
                        this._currentDocument = documents[0];
                        this.processTextSelected(markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId);
                    }
                    
                });
            }
            else if(markerTextChar.textContent!.length >= 2 && this._currentDocument){
                this.processTextSelected(markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId );
            }
            else
            {
                sel.removeAllRanges();
            } 
        }
    }

    processTextSelected = (markerTextChar:DocumentFragment, page_content:string, storageCurrentProjectId:number,  storageCurrentDocumentId:number) =>{
        if(this._currentDocument){
     
            if(markerTextChar.childElementCount == 2){

                var textAnnotation =  markerTextChar.firstChild!.textContent!.split('\n')[0];
                var textAnnotationLast = markerTextChar.lastChild!.textContent!;
                var [newDocumentContent, paragraphIds] = joinAnnotationsSelected(this._currentDocument, markerTextChar);

                if(newDocumentContent !== '' && storageCurrentDocumentId == this._currentDocument!.id){
                    
                    var textWithSpace = textAnnotation.trim() + ' ' + textAnnotationLast.trim();
                    var textWithoutSpace = textAnnotation.trim() + textAnnotationLast.trim();
                    this.defineSelectionProcess(textAnnotation,markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId,true)
                    this.defineSelectionProcess(textWithSpace,markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId, false);
                    this.defineSelectionProcess(textWithoutSpace,markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId, false);

                }
            }
            else if(markerTextChar.childElementCount == 0)
            {
                var textAnnotation =  markerTextChar.textContent!;
                this.defineSelectionProcess(textAnnotation,markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId, false);
            }
        }
    }

    updateIndexAnnotationsByParagraph= ( markerTextChar:DocumentFragment, page_content:string, storageCurrentProjectId:number,  storageCurrentDocumentId:number, removedParagraphIds:number[]) =>{
        //obtener las anotaciones existentes del documento
        this._annotationsService.getByDocumentId(this._currentDocument?.id!).then(annotations => {
            const secondChild = markerTextChar.lastChild;
            if (secondChild instanceof HTMLElement) {
                const secondParagraphId = secondChild.getAttribute('id');
                var updatedAnnotations:Annotation[] = [];
                //actualizar el index de cada anotacion existente en el parrafo
                updateIndexAnnotationsByJoin(annotations, markerTextChar, secondParagraphId, updatedAnnotations);
                

                if(removedParagraphIds.length > 0){
                    //actualizar el parrafo en caso que sea removido el segundo parrafo al ser seleccionado completamente
                    updateParagraphAnnotationsByJoin(annotations, removedParagraphIds[0], updatedAnnotations);
                }
                
                this._annotationsService.updateBulk(updatedAnnotations).then(result =>{
                    //actualizar el texto del documento
                    var documentUpdateResult = this._documentService.update(this._currentDocument!);
                    documentUpdateResult.then(result => {
                        //crear las nuevas anotaciones de la union de los parrafos
                        this.textPlain = removeSpecialCharacters( readBinaryContent(this._currentDocument!.textContent));
                        this.defineSelectionProcess(markerTextChar.textContent!.replaceAll('\n',''),markerTextChar, page_content, storageCurrentProjectId, storageCurrentDocumentId, false);
                    });
                });

            }
        });
    }

    updateDocumentStats = () =>{
        var result = this._annotationsService.executeFieldCounter(this._currentDocument!.id);
        result.then(resultRequest => {
            if(this._currentDocument){
                this._currentDocument.placeNames = resultRequest;
                var documentUpdateResult = this._documentService.update(this._currentDocument!);
                documentUpdateResult.then(result => {
                    this.showDocumentWithAnnotations();
                });

            }
        });
        
    }

    showFieldStats = (fieldCode:string):number=>{
        var counter = 0;
        if(this._currentDocument?.placeNames){
            
            var documentStats = this._currentDocument?.placeNames?.find(stat => stat.fieldCode === fieldCode);
            if(documentStats){
                var counters = documentStats.placeNames.map(placeName => placeName.count);
                counter =  counters.reduce((acumulador, valorActual) => acumulador + valorActual, 0);

            }
            
        }


        return counter;
    }

    getPlaceNameStats = (fieldCode:string):PlaceNameStatsItem[]=>{
        var placeNameList: PlaceNameStatsItem[] =[];
        if(this._currentDocument?.placeNames){
            var list = this._currentDocument?.placeNames.filter(stat => stat.fieldCode === fieldCode);
            if(list.length > 0)
            {
                if(list[0].placeNames)
                    placeNameList = list[0].placeNames;
            }
        }
        return placeNameList;
    }

    defineSelectionProcess = (textAnnotation:string, markerTextChar:DocumentFragment, page_content:string, storageCurrentProjectId:number,  storageCurrentDocumentId:number, isRelated:boolean) => {
        this.setValuesToAnnotationSelected(textAnnotation, page_content);
        if(storageCurrentProjectId !== this._currentProject.id){
            this.loadDocumentList(storageCurrentProjectId, storageCurrentDocumentId);
        }
        else if(storageCurrentDocumentId == this._currentDocument!.id ){          
            this.setState({isOverAnnotations:false});
            this.setState({isSavingAnnotation:true});
            if(isRelated){
                const secondChild = markerTextChar.lastChild;
                const firstChild = markerTextChar.firstChild;
                this.addAnnotationRelated(firstChild, secondChild);
                
            
            }else{
                this.searchAnnotationMatches(this._tmpAnotationSelected,this._annotationsList);              
            }
        }
    }

    setValuesToAnnotationSelected = (textAnnotation:string, page_content:string) =>{
        var selectedIndex = page_content.indexOf(textAnnotation);
        
        this._tmpAnotationSelected.id = undefined;
        this._tmpAnotationSelected.text = textAnnotation.trim();
        this._tmpAnotationSelected.start = selectedIndex;
        this._tmpAnotationSelected.end = selectedIndex + textAnnotation.trim().length;
        this._tmpAnotationSelected.documentId = this._currentDocument!.id;
        this._tmpAnotationSelected.isUniqueMode = false;
    }



    loadDocumentList = (storageCurrentProjectId: number, storageCurrentDocumentId: number) => {
        var result = this._documentService.getList(storageCurrentProjectId);
        result.then(res => {
            this.documentList = res? (res as Document[]): ([] as Document[]);      
            this.documentList.sort((a, b) => a.sort - b.sort);
            if(this.documentList.length > 0){
                let indexCurrentDocument = this.documentList.findIndex(itemIndex => itemIndex.id === storageCurrentDocumentId);
                if(indexCurrentDocument !== -1){
                    this.documentList[indexCurrentDocument].isSelected = true;
                    this.setState({isOverAnnotations:false});
                    this.setState({isSavingAnnotation:true});
                    
                    this.showDocument(this.documentList[indexCurrentDocument]);
                    this.forceUpdate();
                    
                        this.searchAnnotationMatches(this._tmpAnotationSelected, this._annotationsList);
                }
            
            
            }
        });
    }

    addAnnotationRelated = (firstChildNode:ChildNode | null, secondChildNode: ChildNode | null) =>{
        
        if (firstChildNode instanceof HTMLElement && secondChildNode instanceof HTMLElement ) {
            const firstParagraphId = firstChildNode.getAttribute('id');
            const secondParagraphId = secondChildNode.getAttribute('id');
            var dateNow = Date.now();
            const timespan:string = new Date(dateNow).toISOString().replace('.','_');
    
           
            if(firstParagraphId && secondParagraphId){
         
                var firstAnnotation = this.createAnnotation(firstChildNode, this._currentDocument!.id, firstParagraphId, this._tmpAnotationSelected, true);
                var secondAnnotation = this.createAnnotation(secondChildNode, this._currentDocument!.id, secondParagraphId, this._tmpAnotationSelected, false);


                if(firstAnnotation && secondAnnotation){
                    firstAnnotation.relatedText = firstAnnotation?.text + secondAnnotation.text;
                    firstAnnotation.relatedKey = timespan + this._currentDocument?.title + '_' + firstParagraphId + '_' + firstAnnotation.start + ' ' + firstAnnotation.text;
                    this._annotationsService.add(firstAnnotation).then(result =>{
                        if(secondAnnotation){
                            secondAnnotation.relatedTo = result;
                            secondAnnotation.relatedText = firstAnnotation?.text + secondAnnotation.text
                            secondAnnotation.relatedKey = timespan + this._currentDocument?.title + '_' + firstParagraphId + '_' + firstAnnotation!.start + ' ' + firstAnnotation!.text;

                            this._annotationsService.add(secondAnnotation).then(result =>{
                                firstAnnotation!.id = secondAnnotation!.relatedTo;
                                firstAnnotation!.relatedTo = secondAnnotation!.id!;

                                this._annotationsService.update(firstAnnotation!).then(result =>{
                                
                                this.showDocumentWithAnnotations();
                            
                                }); 
                            });   
                        }
                    });
                }   
                
            }
        }
        
    }

    createAnnotation = (childnode:ChildNode, documentId:number, paragraphId: string, annotationSelected: Annotation, isFirstChild:boolean): Annotation|null =>{

        var newAnnotation = createNewAnnotation(documentId);
        if(childnode.textContent ){
            const textContent = childnode.textContent.replace('\n','');
            var paragraphContent = document.getElementById(paragraphId)!.textContent!;
            var startIndex = (isFirstChild)?paragraphContent.lastIndexOf(textContent):paragraphContent.indexOf(textContent);            
            newAnnotation.text =  textContent;
            newAnnotation.start = startIndex;
            newAnnotation.end = startIndex + textContent.length;
            newAnnotation.paragraph = paragraphId;
            newAnnotation.firstEntityId = (annotationSelected.firstEntityId)?annotationSelected.firstEntityId!:-1;
            newAnnotation.secondEntityId = (annotationSelected.secondEntityId)?annotationSelected.secondEntityId!:-1;
            newAnnotation.firstEntityCode = (annotationSelected.firstEntityCode)?annotationSelected.firstEntityCode:'';
            newAnnotation.secondEntityCode = (annotationSelected.secondEntityCode)?annotationSelected.secondEntityCode:'';
            newAnnotation.fieldsFirstEntity = annotationSelected.fieldsFirstEntity;
            newAnnotation.fieldsSecondEntity = annotationSelected.fieldsSecondEntity;

            return newAnnotation;

        }else{
            return null;
        }
       
        
    }

    searchAnnotationMatches =  (newAnnotation:Annotation, annotationList:Annotation[]) => {
        //creo las nuevas anotaciones
        this._AnnotationsSelectedList = [];
        if(newAnnotation.text !== "" ){
            this._AnnotationsSelectedList = findNewAnnotationsInText(newAnnotation,annotationList,this.textPlain,this._currentDocument?.id!,this._currentDocument?.projectId!, this.getEntityById( newAnnotation.firstEntityId), this.getEntityById(newAnnotation.secondEntityId));
            this.handleSaveAnnotations();
        }
    } 
    /**
     * Carga de las entitidades cargados en el anotador
     */
    loadEntities = () => {
        var result = this.entityService.getList(this._currentProjectId);
        result.then(res =>
        {
            this.entityList = res? (res as Entity[]): ([] as Entity[]); 
            this.forceUpdate();
        });
    }

    getEntityById = (entityId:number):Entity|undefined => {
        var entityInfo:Entity|undefined = undefined;
        if(this.entityList.length> 0)
        {
            entityInfo = this.entityList.find(entity => entity.id === entityId);
        }
        return entityInfo;
    }

    getFieldByCode = (code: string, entityId:number):Field|undefined => {
        var field:Field|undefined = undefined;
        var entity = this.getEntityById(entityId);

        if(entity)
            field = entity.FieldList?.find((field)=> field.code === code);

        
        return field;
    }

    showHighlight = (placeName: Annotation) => {
        var htmlElement = document.getElementById(placeName.id!.toString()) as HTMLElement;

        htmlElement?.removeAttribute("class");
        htmlElement?.setAttribute("class","annotated-content area-entity-label-highlight");
    }

    hideHighlight =() =>{
         var docElements = document.getElementsByClassName('area-entity-label-highlight');
        var htmlElements = Array.from(docElements);
        htmlElements.forEach((htmlElement ) => {
              htmlElement?.removeAttribute("class");
            htmlElement?.setAttribute("class","annotated-content");
        });
      
    }

    showShadow = (placeNameId:number) =>{
        var htmlElement = document.getElementById(placeNameId.toString()) as HTMLElement;

        htmlElement.removeAttribute('class');
        htmlElement.setAttribute('class','annotated-content area-entity-label-highlight area-entity-label-boxshadow');
    
    }

    hideShadow =() =>{
         var docElements = document.getElementsByClassName('area-entity-label-boxshadow');
        var htmlElements = Array.from(docElements);
        htmlElements.forEach((htmlElement ) => {
              htmlElement?.removeAttribute("class");
            htmlElement?.setAttribute("class","annotated-content area-entity-label-highlight");
        });
      
    }

    handleExportData = (exportFormatValue: number) => {

        var result = this._annotationsService.getAllAnnotations();
        result.then(annotations => {
            const documentIds = this.documentList.map(document => document.id);
            var annotationsOfProject = annotations.filter(annotation => documentIds.includes(annotation.documentId) );
            //this._exportService.startExportProcess(EXPORT_FORMAT_NER, annotationsOfProject, this.entityList, this.documentList);
            this._exportService.startExportProcess(exportFormatValue, annotationsOfProject, this.entityList, this.documentList);
        });
    }
    
    handleOpen = () => {
        this.setState({ openExportDialog:true});
      };
    handleClose = () => {
        this.setState({ openExportDialog:false});
      };

      handleExportFormatChange = (event: React.ChangeEvent<HTMLInputElement>) =>{
          this.setState({exportFormatSelected: (event.target as HTMLInputElement).value});
      }

    handleClearLabelMatches =() =>{
        this.setState({placeNamesList: []});
        this.showDocumentWithAnnotations();

        this.handleClearLabelSelected();
    }

    handleClearLabelSelected = ()=>{
        var documentHtmlElements = document.getElementsByClassName('area-entity-field-label-item');

        var htmlElements = Array.from(documentHtmlElements);
        htmlElements.forEach((htmlElement ) => {
            htmlElement?.removeAttribute("class");
  
            htmlElement?.setAttribute("class","area-entity-field-label-item");
            
        });
    }

    handleLabelSelected = (placeName:string, fieldCode:string, entityCode:string) => {
        var documentHtmlElements = document.getElementsByClassName('area-entity-field-label-item');

        var htmlElements = Array.from(documentHtmlElements);
        htmlElements.forEach((htmlElement ) => {
            htmlElement?.removeAttribute("class");
            if(htmlElement.getAttribute('id') === fieldCode+placeName){
                htmlElement?.setAttribute("class","area-entity-field-label-item area-entity-field-label-item-selected");
            }else{
                htmlElement?.setAttribute("class","area-entity-field-label-item");
            }
        });
        


        var newPlaceNames = this._annotationsList.filter(ann  => ((ann.firstEntityCode === entityCode && ann.fieldsFirstEntity?.find(field => field === fieldCode)) || ann.secondEntityCode === entityCode && ann.fieldsSecondEntity?.find(field => field === fieldCode)) &&  (ann.text === placeName && ann.relatedTo === -1 || ann.relatedTo !== -1 && ann.relatedText === placeName) );
        this.hideHighlight();
        newPlaceNames.forEach((placeName,index) => {
            this.showHighlight(placeName);
            if(index === 0)
            {
                this.handleScrollPlacename(placeName.id!);
            }
        });
        this.setState({placeNamesList: newPlaceNames});
        
    }

    handleScrollPlacename = (placeNameId: number) =>{
        this.hideShadow();
        setTimeout(() => {
          document.getElementById(placeNameId.toString())!.scrollIntoView({block: 'center', behavior: 'smooth'});
        this.showShadow(placeNameId);
        }, 300);
    }

    handleSetToolStatus = (toolHTML: HTMLElement, toolId: string) => {
        if(toolHTML.classList.contains('show')){
                        sessionStorage.setItem(ANNOTATOR_TOOL_STATUS+'_'+toolId, ANNOTATOR_TOOL_STATUS_SHOW);
                        switch (toolId){
                            case 'dropdown-btn-details':

                                if(this.getDetailsToolHeight() === 0){
                                    this.setDetailsToolHeight(ANNOTATOR_TOOL_DEFAULT_HEIGHT);
                                }
        
                                this.setState({heightDetails: this.getDetailsToolHeight()});
                                break;
                            case 'dropdown-btn-labels':

                                if(this.getLabelsToolHeight() === 0){
                                    this.setLabelsToolHeight(ANNOTATOR_TOOL_DEFAULT_HEIGHT);
                                }
                             
                                this.setState({heightLabels: this.getLabelsToolHeight()});
                                break;
                            case 'dropdown-btn-matches':
                                break;
        
                        }
                    }else
                    {
                         sessionStorage.setItem(ANNOTATOR_TOOL_STATUS+'_'+toolId, ANNOTATOR_TOOL_STATUS_HIDDEN);
        
                         switch (toolId){
                            case 'dropdown-btn-details':
                                this.setDetailsToolHeight(0);
                                this.setState({heightDetails: 100});
                                break;
                            case 'dropdown-btn-labels':
                                this.setLabelsToolHeight(0);
                                this.setState({heightLabels: 100});
                                break;
                            case 'dropdown-btn-matches':
        
                                break;
        
                        }
                    }
    }

    handleGetToolStatus = () =>{
        var detailsToolStatus = sessionStorage.getItem(ANNOTATOR_TOOL_STATUS+'_'+'dropdown-btn-details');
        var labelsToolStatus = sessionStorage.getItem(ANNOTATOR_TOOL_STATUS+'_'+'dropdown-btn-labels');
        var matchesToolStatus = sessionStorage.getItem(ANNOTATOR_TOOL_STATUS+'_'+'dropdown-btn-matches');

        if(detailsToolStatus === ANNOTATOR_TOOL_STATUS_SHOW){
            this.handleToggleSubContainer('dropdown-btn-details');
            var detailsToolHeight = sessionStorage.getItem(ANNOTATOR_TOOL_DETAILS_HEIGHT);
            if(detailsToolHeight == null || parseInt(detailsToolHeight) === 0){
                sessionStorage.setItem(ANNOTATOR_TOOL_DETAILS_HEIGHT, ANNOTATOR_TOOL_DEFAULT_HEIGHT.toString());
            }
        }else
        {
            sessionStorage.setItem(ANNOTATOR_TOOL_DETAILS_HEIGHT, '0');
        }

        

        if(labelsToolStatus === ANNOTATOR_TOOL_STATUS_SHOW){
            this.handleToggleSubContainer('dropdown-btn-labels');
            var labelsToolHeight = sessionStorage.getItem(ANNOTATOR_TOOL_LABELS_HEIGHT);
            if(labelsToolHeight == null || parseInt(labelsToolHeight) === 0){
                sessionStorage.setItem(ANNOTATOR_TOOL_LABELS_HEIGHT, ANNOTATOR_TOOL_DEFAULT_HEIGHT.toString());
            }
        }else{
            sessionStorage.setItem(ANNOTATOR_TOOL_LABELS_HEIGHT, '0');
        }

        if(matchesToolStatus === ANNOTATOR_TOOL_STATUS_SHOW){
            this.handleToggleSubContainer('dropdown-btn-matches');
        }else
        {

        }
    }

    handleToggleSubContainer  =  (toolId: string) => {
        const currentEl = document.getElementById(toolId) as HTMLElement | null;
        if(currentEl){
            const nextEl = currentEl.nextElementSibling as HTMLElement | null;
                    if(nextEl){
                        nextEl.classList.toggle('show');
                        currentEl.classList.toggle('rotate');
                        currentEl.classList.toggle('dropdown-selected');
                        this.handleSetToolStatus(nextEl,toolId);
                    }
        }
       
    }

    setDetailsToolHeight = (height:number) =>{
        sessionStorage.setItem(ANNOTATOR_TOOL_DETAILS_HEIGHT, height.toString());
    }

    setLabelsToolHeight = (height:number) =>{
        sessionStorage.setItem(ANNOTATOR_TOOL_LABELS_HEIGHT, height.toString());
    }

    getDetailsToolHeight = ():number=>{
        var detailsToolHeight = sessionStorage.getItem(ANNOTATOR_TOOL_DETAILS_HEIGHT);
        return parseInt(detailsToolHeight!);
    }

    getLabelsToolHeight = ():number=>{
        var detailsToolHeight = sessionStorage.getItem(ANNOTATOR_TOOL_LABELS_HEIGHT);
        return parseInt(detailsToolHeight!);
    } 

    setDetailsStatus = (active: boolean, height: number)=>{
       this.setState({activeDragDetails: active, heightDetails: height});
    }

    setLabelsStatus = (active: boolean, height: number)=>{
       this.setState({activeDragLabels: active, heightLabels: height});
    }
    
    render(): React.ReactNode {
        
        return(<div className="container-main" onContextMenu={(e:any) => {e.preventDefault();}}>
            <Dialog
                        open={this.state.openExportDialog}
                        onClose={this.handleClose}
                        PaperProps={{
                        component: 'form',
                        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                            event.preventDefault();
                            if(this.state.exportFormatSelected === 'GTA')
                            {
                                this.handleExportData(EXPORT_FORMAT_TAGTOG);
                                
                            }
                            else if(this.state.exportFormatSelected === 'NER')
                            {
                                this.handleExportData(EXPORT_FORMAT_NER);
                            }

                            this.handleClose();
                        },
                        }}
                    >
                        <DialogTitle>Export Data</DialogTitle>
                        <DialogContent>
                            <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">Choose a format to export annotations.</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="female"
                                    name="radio-buttons-group"
                                    value={this.state.exportFormatSelected}
                                    onChange={this.handleExportFormatChange}
                                >
                                    <FormControlLabel value="NER" control={<Radio />} label="NER" />
                                    <FormControlLabel value="GTA" control={<Radio />} label="GTA" />
                                </RadioGroup>
                            </FormControl>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={this.handleClose}>Cancel</Button>
                        <Button type="submit">Export</Button>
                        </DialogActions>
                    </Dialog>
        <div id="SideNav" className="area-sidenav">
            <div className="area-tool-container-nav">
                <div id="NavPlatform" className="area-plat-nav area-tool">
                    <div className="area-tool-container">
                        
                            <div className="area-details-header-nav">
                                <div className="area-details-nav"><span className="entity-selected-back" onClick={this.props.backProjects}>Projects </span> <span className="annotator-project-title">  / {this._currentProject.name}</span></div>
                            </div>
                    
                    </div>  
                </div>
                <div id="PlattformImage" className="area-plat-image area-tool">
                    <div className="area-tool-container">
                        <div className="area-details-header">
                        <div className="area-details-header-content">
                            <i className="area-details-title">Documents</i>
                            <div className="container-input-document">
                                <input type="file" onChange={this.handleFileChange} name="file-1" id="documentFile" accept=".txt" className="inputfile-document inputfile-document-1"  multiple/>
                                <label htmlFor="documentFile">
                                    <span className="material-symbols-outlined area-documents-add-icon">
                                        Add
                                    </span>
                                </label>
                
                            </div>
                        </div>
                        <div id="area-corpus-separator" className="separator separator-blue"></div>
                    </div>
                        <DocumentList list={this.documentList} showDocument={this.showDocument}/>
                    </div>
                </div>
                <div id="EntityList" className="area-entity-list area-tool">
                <div className="area-tool-container">
                    <div className="area-details-header">
                    <div className="area-details-header-content">
                        <i className="area-details-title">Entities</i>
                    </div>
                    <div id="area-corpus-separator" className="separator separator-blue"></div>
                    </div>
                    <div style={{display: 'none'}} className="area-entities-filter">
        
                    <button type="button" className="button-option button-option-unselected ">
                        Aa
                    </button>
                    <button type="button" className="button-option button-option-unselected " data-bs-toggle="modal" data-bs-target="#exampleModal">
                        ab
                    </button>
                    </div>
                    <div className="area-entities-list">
                        {
                            
                            this.entityList.map((entity) => (
                            <div className="area-entity-item-container">
                                <div className="area-entity-item">
                                    <Checkbox size="small" checked={entity.selected} indeterminate={this.handleCheckSemiSelected(entity)} onChange={() => this.handleEntityCheckChange(entity)} className="area-entity-checkbox"/>
                                    
                                    <div className="area-entity-circle" style={{background: entity.Color}}></div>
                                    <div className="area-entity-data"><span className="area-entity-label">{entity.Entity}</span> </div>
                                    <span onClick={() => this.handleFieldListStatus(entity.id!,'FieldList_')} className="material-symbols-outlined  arrow-field-list">
                                                arrow_drop_up
                                                </span>
                                </div>
                                
                                <div id= {'FieldList_' + entity.id?.toString()} className="area-entity-fields-container">
                                    {
                                        entity.FieldList!.map((field) => (
                                            <div className="area-entity-field-item-container">
                                                <div className="area-entity-field-item">
                                                    <input type="checkbox" checked={field.selected} onChange={() => this.handleFieldCheckChange(field)} className="area-entity-checkbox"/>
                                                    <div className="area-entity-data"><span className="area-entity-label-field"> {field.name}</span></div>                      
                                                </div>   
                                        </div>
                                        ))
                                    }
                                    
                                </div>
                            </div>
                            ))
                        }
                            
                        
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div className="area-container">
            
            <CorpusComponent handleExportAnnotations={this.handleOpen} Entities={this.entityList} refreshData={this.refreshCurrentAnnotation} isOpenNewDocument={this.state.isOpenNewDocument} allowContextMenu={this.handleAllowContextMenu} isSavingNewAnnotation={this.state.isSavingAnnotation} handleSaveAnnoations={this.handleSaveDraftAnnotations} handleUpdateDocumentStats={this.updateDocumentStats} Annotation={this.state.annotationSelected} isOverAnnotation={this.state.isOverAnnotations} AnnotationList={this._annotationsList} AnnotationsSelected={this._AnnotationsSelectedList} showAnnotations={this.handleShowAnnotations} />
           
            <div id="Details" className="area-details area-tool">
                    <div className="area-tool-details-container" id='ContainerDetailsRef'>
                        <nav id="sidebar">
                                <ul>
                                    <li>
                                        <button  id="dropdown-btn-details" onClick={() => this.handleToggleSubContainer('dropdown-btn-details')} className="dropdown-btn">
                                            <span className="dropdown-btn-title">Annotation Details</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
                                        </button>
                    
                                        <ToolList AnnotationSelected={this.state.annotationSelected} 
                                        TmpAnnotationSelected={this._tmpAnotationSelected} 
                                        getEntityById={this.getEntityById} 
                                        getFieldByCode={this.getFieldByCode} 
                                        activeDragDetails={this.state.activeDragDetails} 
                                        heightDetails={this.state.heightDetails} 
                                        heightDetailsSaved={this.getDetailsToolHeight()} 
                                        containerDetailsRef={this.state.containerDetailsRef} 
                                        dropdownToolDetailsRef={this.state.dropdownToolDetailsRef} 
                                        setDetailsStatus={this.setDetailsStatus}></ToolList>
                                         
                                        
                                    </li>
                                     <li>
                                        <button  id="dropdown-btn-labels" onClick={() => this.handleToggleSubContainer('dropdown-btn-labels')}  className="dropdown-btn">
                                            <span className="dropdown-btn-title">Counter</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
                                        </button>
                                        <ToolLabelList 
                                        EntityList={this.entityList} 
                                        activeDrag={this.state.activeDragLabels} 
                                        height={this.state.heightLabels} 
                                        heightSaved={this.getLabelsToolHeight()} 
                                        containerRef={this.state.containerDetailsRef} 
                                        dropdownToolRef={this.state.dropdownToolLabelsRef} 
                                        setStatus={this.setLabelsStatus} 
                                        handleFieldListStatus={this.handleFieldListStatus} 
                                        showFieldStats={this.showFieldStats} 
                                        getPlaceNameStats={this.getPlaceNameStats} 
                                        handleLabelSelected={this.handleLabelSelected} ></ToolLabelList>
                                        
                                    </li>
                                    <li>
                                        <button id="dropdown-btn-matches" onClick={() => this.handleToggleSubContainer('dropdown-btn-matches')}  className="dropdown-btn">
                                            <span className="dropdown-btn-title">Matches</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
                                        </button>
                                        <div className="sub-container">
                                            <div className="area-entities-counter-list">
                                               <LabelMatches matches={this.state.placeNamesList} onScroll={this.handleScrollPlacename} />
                                            </div>
                                        </div>
                                    </li>
                                    
                                </ul>
                        </nav>
                    </div>
            </div>
        </div>
    </div>
    );
    }
}

export default Anotator;

